module.exports = __webpack_public_path__ + "static/media/horus-bco.588a6a1b.svg";